import { render } from "./MessageEcho.vue?vue&type=template&id=43eaaf63&scoped=true&ts=true"
import script from "./MessageEcho.vue?vue&type=script&lang=ts"
export * from "./MessageEcho.vue?vue&type=script&lang=ts"

import "./MessageEcho.vue?vue&type=style&index=0&id=43eaaf63&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43eaaf63"]])

export default __exports__